import React, { useContext, useEffect, useState } from 'react';
import { OnScreenContext } from '@/components/common/HorizontalScrollMenu/OnScreenContext';
import { VisibilityContext, type publicApiType } from 'react-horizontal-scrolling-menu-7';
import styles from '../HorizontalScrollMenu.module.scss';
import Arrow from './Arrow';

type RightArrowProps = {
  isDisabled?: boolean,
};

export const RightArrow = ({ isDisabled } : RightArrowProps) => {
  const visibility = useContext<publicApiType>(VisibilityContext);
  const isAdjacentItemVisible = visibility.useIsVisible('last', false);

  const isOnScreen = useContext(OnScreenContext);
  const [disabled, setDisabled] = useState(isAdjacentItemVisible);

  useEffect(() => {
    if (isOnScreen) {
      setDisabled(isAdjacentItemVisible);
    }
  }, [isOnScreen, isAdjacentItemVisible]);

  const onClick = () => visibility.scrollToItem(visibility.getNextElement(), 'smooth', 'end');

  return (<Arrow arrowClass={styles.nextArrow} isDisabled={isDisabled || disabled} onClick={onClick} />);
};

export default RightArrow;
